// extracted by mini-css-extract-plugin
export var checkbox = "_3d-0";
export var circle = "_3d-3";
export var horizontalContainer = "_3d-7";
export var sm = "_3d-5";
export var switch0 = "_3d-2";
export var switchDisabled = "_3d-8";
export var switchEnabled = "_3d-1";
export var textSwitchContainer = "_3d-9";
export var textSwitchOption = "_3d-a";
export var textSwitchOptionSelected = "_3d-b";
export var verticalContainer = "_3d-6";
export var xs = "_3d-4";